/**
 * A pseudorandom number source. It takes a seed integer
 * so that with the same seed the same random sequence is
 * produced.
 */
export class RandomSourceWithSeed {
  constructor(private seed: number) {}

  next(): number {
    const x = Math.sin(this.seed++) * 10000;
    return x - Math.floor(x);
  }

  nextIntInRange(min: number, max: number): number {
    const diff = max - min + 1;
    return (this.next() * diff + min) | 0;
  }

  nextFloatInRange(min: number, max: number): number {
    return this.next() * (max - min) + min;
  }

  reset(seed: number) {
    this.seed = seed;
  }
}

export function genMonochromeNoiseBitmap(channels: number, dim: number, randomSeed: number, flipY = false) {
  const randomSource = new RandomSourceWithSeed(randomSeed);

  const pixelCount = dim * dim;
  const buffer = new Uint8Array(channels * pixelCount);

  for (let y = 0; y < dim; ++y) {
    for (let x = 0; x < dim; ++x) {
      const randomValue = Math.floor(randomSource.next() * 255.9999);
      const pixelInd = x + (flipY ? dim - y - 1 : y) * dim;
      for (let c = 0; c < channels; ++c) {
        buffer[pixelInd * channels + c] = randomValue;
      }
    }
  }
  return buffer;
}
